import { InjectionToken } from "@angular/core";

import { MatCoreConfig } from "./model";

export const MAT_CORE_CONFIG = new InjectionToken<MatCoreConfig>("matCoreConfig");

/**
 * @internal
 */
export const _MAT_CORE_CONFIG = new InjectionToken<MatCoreConfig | (() => MatCoreConfig)>("_matCoreConfig");
